import { Component, inject, computed, effect } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PageLayoutComponent } from '../../shared/ui/page-layout/page-layout.component';
import { PageTitleService } from '../../services/page-title.service';
import { AuthService } from '../../core/services/auth.service';
import { PunchClockComponent } from '../attendance/daily-attendance/punch-clock/punch-clock.component';
import { DashboardGridComponent } from './widgets/dashboard-grid.component';
import { PermissionService } from 'src/app/core/services/permission.service';
import { SCOPES } from 'src/app/core/constants/permissions';
import Keycloak from 'keycloak-js';

@Component({
  selector: 'app-dashboard',
  standalone: true,
  imports: [CommonModule, PageLayoutComponent, PunchClockComponent, DashboardGridComponent],
  templateUrl: './dashboard.component.html'
})
export class DashboardComponent {
  private pageTitleService = inject(PageTitleService);
  private permission = inject(PermissionService);

  private auth = inject(AuthService);
  canview = computed(() => this.permission.has(SCOPES.DASHBOARD_VIEW));
  private keycloak = inject(Keycloak);
  public authService = inject(AuthService);

  greeting = computed(() => {
    const h = new Date().getHours();
    if (h < 12) return 'Good morning';
    if (h < 17) return 'Good afternoon';
    return 'Good evening';
  });

  roleLabel = computed(() => {
    const role = this.auth.currentUserRole();
    const map: Record<string, string> = {
      hr_admin: 'HR Admin',
      intern_hr: 'HR',
      employee: 'Employee',
      MANAGER: 'Manager',
      ADMIN: 'Admin',
      USER: 'User'
    };
    return map[role] ?? role;
  });

  today = new Date().toLocaleDateString('en-GB', { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' });

  constructor() {
    this.loggedInInitialization();
    effect(() => {
      this.pageTitleService.setTitle(this.canview() ? '' : 'Dashboard');
    });
  }

  loggedInInitialization() {

    // console.log('Authenticated:', authenticated);
    console.log('Token:', this.keycloak.token);
    console.log('User Info:', this.keycloak.profile);
    console.log('Realm roles:', this.keycloak.tokenParsed?.realm_access?.roles);

    const token = this.keycloak?.token;
    if (token) {
      this.authService.saveToken(token, true);
    }

    // this.authenticated.set(authenticated);
    // this.initialized.set(true);

    // this.keycloak.onTokenExpired = () => {
    //   this.keycloak.updateToken(30).catch(() => this.keycloak.login());
    // };

    // return authenticated;
  }
}
